/*
 * Copyright (c) 2023-2025 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
/**
 * Translation
 */
export const translation = {
  "NotFound": "404 - Η σελίδα δεν βρέθηκε",
  "ComingSoon": "Έρχεται σύντομα",
  "YesanPersonalFinance": "Yesan, Προσωπικά οικονομικά",
  "Yesan": "Yesan",
  "PersonalFinance": "Personal Finance",
  "YesanDownload": "Yesan Λήψη",
  "ThisWebsiteUsesCookies": "Χρησιμοποιούμε cookies για να συλλέγουμε και να αναλύουμε πληροφορίες σχετικά με την απόδοση και τη χρήση του ιστότοπού μας και για να παρέχουμε λειτουργίες κοινωνικών μέσων. Συνεχίζοντας, συναινείτε με τα",
  "IGotIt": "OK",
  "BecomeFinanciallyFree": "Γίνετε οικονομικά ελεύθεροι",
  "inStepsAndActions": "σε 8 βήματα και 3 ενέργειες.",
  "TrackPlanAnalyze": "Παρακολουθήστε το. Σχεδιάστε. Αναλύστε.",
  "FTrack": "1. Παρακολούθηση",
  "FPlan": "2. Σχέδιο",
  "FAnalyze": "3. Ανάλυση",
  "Features": "Χαρακτηριστικά",
  "FeaturesSubHeading": "Αμιγώς αρχάριοι, ήδη οικονομικά καταρτισμένοι, αυτή είναι η εφαρμογή που χρειάζεστε για να γίνετε οικονομικά ελεύθεροι.",
  "ManageAccounts": "Διαχείριση λογαριασμών",
  "CashLiquidFixedAssetsLiabilities": "Μετρητά, ρευστότητα, πάγια περιουσιακά στοιχεία και υποχρεώσεις.",
  "TrackTransactions": "Παρακολουθήστε τις συναλλαγές.",
  "IncomesExpensesTransferInvestments": "Έσοδα, έξοδα, μεταφορές, επενδύσεις.",
  "ImportExport": "Εισαγωγή / Εξαγωγή",
  "YourDataAlwaysAccessible": "Τα δεδομένα σας είναι πάντα προσβάσιμα.",
  "PlanYourFreedom": "Σχεδιάστε την ελευθερία σας",
  "StepsAwayFromFI": "8 βήματα μακριά από την οικονομική ανεξαρτησία.",
  "BudgetsAndGoals": "Προϋπολογισμοί & στόχοι",
  "CheckYourProgressAndAchieve": "Ελέγξτε την πρόοδό σας και επιτύχετε τους οικονομικούς σας στόχους.",
  "DashboardAndAnalytics": "Πίνακας οργάνων & αναλύσεων",
  "ReviewLearnOptimizeWith": "Επανεξετάστε, μάθετε, βελτιστοποιήστε με διαγράμματα, πληροφορίες, εργαλεία.",
  "Security": "Ασφάλεια",
  "MilitaryGradeEncryption": "Κρυπτογράφηση στρατιωτικού βαθμού, υποστήριξη βιομετρίας, αποθήκευση δεδομένων στις συσκευές σας.",
  "OfflineMode": "Λειτουργία εκτός σύνδεσης",
  "YourDataAlwaysAccessibleAndModif": "Τα δεδομένα σας είναι πάντα προσβάσιμα και τροποποιήσιμα.",
  "Track": "Παρακολούθηση",
  "Income": "Εισόδημα",
  "Expense": "Έξοδα",
  "Transfer": "Μεταφορά",
  "transactionsAndManageAccounts": "συναλλαγές & διαχειριστείτε ποικιλία λογαριασμών:",
  "checkings": "Έλεγχος",
  "savings": "Ταμιευτηρίου",
  "realEstate": "Ακίνητη περιουσία",
  "stocks": "Χρηματιστήρια",
  "bonds": "Ομόλογα",
  "crypto": "Κρυπτογράφηση",
  "notes": "Χαρτονομίσματα, μετρητά Πορτοφόλι",
  "envelopes": "Φάκελοι",
  "privateEquity": "Ιδιωτικά Μετοχικά Κεφάλαια",
  "metal": "Μέταλλο",
  "retirement": "Συνταξιοδότηση",
  "lifeInsurance": "Ασφάλειες Ζωής",
  "intellectualProperty": "Πνευματική ιδιοκτησία",
  "otherLiquidAsset": "Άλλα ρευστά περιουσιακά στοιχεία",
  "otherFixedAsset": "Άλλα πάγια περιουσιακά στοιχεία",
  "mortgage": "Υποθήκη",
  "loan": "Καταναλωτικό δάνειο",
  "creditCard": "Πιστωτική κάρτα",
  "otherLiability": "Άλλο παθητικό",
  "AccountsManagement": "Διαχείριση λογαριασμών",
  "MultipleAccountsTypesAndGrouping": "Πολλαπλοί τύποι λογαριασμών και ομαδοποίηση",
  "LinkAccounts": "Σύνδεση λογαριασμών από τα ιδρύματά σας (διαθέσιμη μόνο σε ορισμένες χώρες)",
  "SmartAccounts": "Έξυπνοι λογαριασμοί",
  "AddEditDeleteTransactions": "Προσθήκη/επεξεργασία/διαγραφή συναλλαγών",
  "TickVerifiedTransactions": "Μαρκάρισμα επαληθευμένων συναλλαγών",
  "CategorizeTransactions": "Κατηγοριοποίηση συναλλαγών",
  "TagTransactions": "Ετικέτες συναλλαγών",
  "TrackKakeiboType": "Παρακολούθηση τύπου Kakeibo",
  "TrackInvestments": "Παρακολούθηση επενδύσεων (διαθέσιμο μόνο σε ορισμένες χώρες)",
  "ImportFromCSVFile": "Εισαγωγή πλήρους ή σταδιακής εισαγωγής συναλλαγών από αρχείο CSV",
  "ExportToCSVFile": "Εξαγωγή συναλλαγών σε αρχείο CSV",
  "stepsTowardsFIPlanBudgetingReachGoals": "Σχέδιο 8 βημάτων προς την οικονομική ανεξαρτησία, λεπτομερής κατάρτιση προϋπολογισμού, επίτευξη των οικονομικών σας στόχων γρηγορότερα.",
  "levelsTowardsFI": "8 επίπεδα προς την οικονομική ανεξαρτησία",
  "EstablishBudgetsPer": "Κατάρτιση προϋπολογισμών ανά",
  "account": "λογαριασμό",
  "accountType": "Τύπος λογαριασμού",
  "KakeiboType": "Τύπος Kakeibo",
  "category": "κατηγορία",
  "tag": "ετικέτα",
  "label": "ετικέτα",
  "TrackBudgetsPerFrequency": "Παρακολούθηση προϋπολογισμών ανά συχνότητα",
  "CreateGoalsOnSpendingBalanceCashFlowActions": "Δημιουργήστε στόχους σχετικά με τις δαπάνες, το υπόλοιπο, τις ταμειακές ροές, τις ενέργειες",
  "TrackGoalsProgress": "Παρακολούθηση της προόδου των στόχων",
  "ReviewLearnOptimizeWithReportsCharts": "Επανεξέταση, μάθηση, βελτιστοποίηση με αναφορές, διαγράμματα, τάσεις, πληροφορίες, εργαλεία.",
  "Dashboard": "Ταμπλό",
  "FSNetWorth": "Οικονομικές καταστάσεις: Καθαρή αξία",
  "FSPnL": "Οικονομικές καταστάσεις: Κέρδη & Ζημίες",
  "FSBalanceSheetAssetsLiabilities": "Οικονομικές καταστάσεις: Ισολογισμός, Ενεργητικό, Παθητικό",
  "FSCashFlow": "Οικονομικές καταστάσεις: Χρέωση Πίστωση, Ροές",
  "FSFlows": "Οικονομικές καταστάσεις: Ροές",
  "FSRatios": "Οικονομικές καταστάσεις: Αριθμοδείκτες",
  "TrendsMonthEnd": "Τάσεις τέλους μήνα: Ταμειακές ροές",
  "TrendsPerformance": "Τάσεις απόδοσης: YoY, MoM, WoW",
  "IncomeTrendsPer": "Τάσεις εισοδήματος ανά",
  "SpendingTrendsPer": "Τάσεις δαπανών ανά",
  "RecurringItemsIE": "Επαναλαμβανόμενα στοιχεία: Έσοδα & Δαπάνες",
  "DebtProgressTrends": "Τάσεις προόδου χρέους",
  "KakeiboMTDReviewTrends": "Kakeibo: Τάσεις: Επισκόπηση MTD, τελευταίος μήνας, τάσεις",
  "FIWCLE": "Οικονομική ανεξαρτησία: Ενέργεια ζωής: Διάγραμμα τοίχου, δαπάνες ανά ζωή",
  "DebtPaydownSnowballAvalanche": "Εξόφληση χρέους: Χιονόμπαλα, χιονοστιβάδα",
  "FullyCustomizableAnalyticsRange": "Πλήρως παραμετροποιήσιμο εύρος χρόνου ανάλυσης",
  "ContactUs": "Επικοινωνήστε μαζί μας",
  "Privacy": "Απόρρητο",
  "Terms": "Όροι",
  "About": "Σχετικά με το",
  "IAgreeToThe": "Συμφωνώ με το",
  "AndThe": "και το",
  "PrivacyPolicy": "Πολιτική απορρήτου",
  "TermsOfUse": "Όροι χρήσης",
  "DigitalSoftwareExperienceTagline": "Ψηφιακή εμπειρία λογισμικού για τον σύγχρονο κόσμο",
  "DigitalExperience": "Ψηφιακή εμπειρία",
  "SoftwareForTheModernWorld": "Λογισμικό για τον σύγχρονο κόσμο",
  "MobileApplications": "Εφαρμογές για κινητά",
  "forConnectedAndOfflineHumans": "για συνδεδεμένους και μη συνδεδεμένους ανθρώπους",
  "CloudSaaS": "Cloud SaaS",
  "ResponsiveAndWebServices": "Ανταποκρινόμενες και διαδικτυακές υπηρεσίες",
  "PersonalFinanceServices": "Προσωπικές οικονομικές υπηρεσίες",
  "YS_p1": "Η Yesan είναι μια δυναμική εταιρεία λογισμικού που ειδικεύεται στην ανάπτυξη εφαρμογών κινητών τηλεφώνων αιχμής προσαρμοσμένων στους καταναλωτές. Με έντονη κατανόηση των εξελισσόμενων αναγκών και προτιμήσεων των σημερινών τεχνολογικά ενημερωμένων χρηστών, η Yesan έχει αφοσιωθεί στη δημιουργία διαισθητικών, ελκυστικών και πλούσιων σε χαρακτηριστικά εμπειριών για κινητά που εμπλουτίζουν τη ζωή των χρηστών της.",
  "YS_p2": "Στον πυρήνα της αποστολής της Yesan βρίσκεται η αδιάκοπη δέσμευση για καινοτομία και δημιουργικότητα, κάθε προϊόν είναι σχολαστικά σχεδιασμένο για να προσφέρει απρόσκοπτη λειτουργικότητα και εξαιρετική εμπειρία χρήστη.",
  "PersonalFinanceApplication": "Προσωπική οικονομική εφαρμογή",
  "YPF_p1": "Το Yesan, Personal Finance είναι μια πρωτοποριακή κινητή εφαρμογή προσωπικών οικονομικών που έχει σχεδιαστεί για να ενδυναμώνει τους χρήστες με ολοκληρωμένα εργαλεία οικονομικής διαχείρισης που είναι εύκολα προσβάσιμα στα χέρια τους. Με ένα κομψό και διαισθητικό περιβάλλον εργασίας, το Yesan, Personal Finance προσφέρει μια ολιστική προσέγγιση στη διαχείριση των οικονομικών, απευθυνόμενο σε χρήστες όλων των επιπέδων οικονομικής παιδείας.",
  "YPF_p2": "Τα βασικά χαρακτηριστικά περιλαμβάνουν την παρακολούθηση του προϋπολογισμού, την κατηγοριοποίηση των δαπανών και την παρακολούθηση των συναλλαγών σε πραγματικό χρόνο, επιτρέποντας στους χρήστες να αποκτήσουν γνώσεις σχετικά με τις συνήθειες των δαπανών τους χωρίς κόπο. Η εφαρμογή προσφέρει επίσης προσαρμόσιμες επιλογές κατάρτισης προϋπολογισμού, επιτρέποντας στους χρήστες να θέτουν οικονομικούς στόχους και να παρακολουθούν την πρόοδό τους με την πάροδο του χρόνου.",
  "YPF_p3": "Επιπλέον, το Yesan, Personal Finance δίνει προτεραιότητα στην ασφάλεια, χρησιμοποιώντας πρωτόκολλα κρυπτογράφησης τελευταίας τεχνολογίας για τη διασφάλιση των ευαίσθητων οικονομικών πληροφοριών των χρηστών. Με μέτρα ασφαλείας τραπεζικού επιπέδου, οι χρήστες μπορούν να συνδέουν με σιγουριά τους λογαριασμούς τους και να συγχρονίζουν τις συναλλαγές τους χωρίς να διακυβεύεται το απόρρητο.",
  "YPF_p4": "Το Yesan, Personal Finance υπερβαίνει τον βασικό προϋπολογισμό, προσφέροντας διορατικές αναλύσεις και εξατομικευμένες συστάσεις για τη βελτιστοποίηση των οικονομικών αποφάσεων. Είτε πρόκειται για τον εντοπισμό πιθανών ευκαιριών αποταμίευσης, την παρακολούθηση επενδυτικών χαρτοφυλακίων ή τη διαχείριση στρατηγικών αποπληρωμής χρέους, η εφαρμογή παρέχει εξατομικευμένες πληροφορίες για να βοηθήσει τους χρήστες να επιτύχουν τους οικονομικούς τους στόχους.",
  "Discover": "Ανακαλύψτε το",
  "Firstname": "Όνομα",
  "Lastname": "Επώνυμο",
  "Company":"Εταιρεία",
  "Subject": "Θέμα",
  "Email": "Ηλεκτρονικό ταχυδρομείο",
  "Message": "Μήνυμα",
  "ThankYouForContactingUs": "Σας ευχαριστούμε που επικοινωνήσατε μαζί μας",
  "ValidFirstnameRequired": "Απαιτείται έγκυρο ονοματεπώνυμο.",
  "ValidLastnameRequired": "Απαιτείται έγκυρο επώνυμο.",
  "ValidEmailAddressRequired": "Παρακαλώ εισάγετε μια έγκυρη διεύθυνση ηλεκτρονικού ταχυδρομείου.",
  "ValidSubjectRequired": "Παρακαλώ επιλέξτε ένα έγκυρο θέμα.",
  "ValidMessageRequired": "Παρακαλώ εισάγετε ένα έγκυρο μήνυμα.",
  "UnableToSendTheFormPleaseRetryLater": "Δεν είναι δυνατή η αποστολή της φόρμας, παρακαλώ επαναλάβετε αργότερα.",
  "Information": "Πληροφορίες",
  "Sales":"Πωλήσεις",
  "Support": "Υποστήριξη",
  "Press": "Τύπος",
  "Partnership": "Συνεργασία",
  "Other": "Άλλα",
  "Blog":"Blog",

  "Accept":"Αποδοχή",
  "Decline":"Απόρριψη",

  "WorklogCalendar":"Ημερολόγιο εργασιών για το Jira",

  "DirectlyAccessibleInProjectApps":"Άμεσα προσβάσιμο στις εφαρμογές έργου",
  "VisualizeWhereYouSpentYourTime":"Οπτικοποιήστε πού ξοδέψατε το χρόνο σας",
  "AllYourWorklogsInACalendar":"Όλα τα αρχεία καταγραφής εργασιών σας σε ένα ημερολόγιο",
  "MonthSummary":"Σύνοψη μήνα",
  "CheckIfYouForgotToLogTime":"Ελέγξτε αν ξεχάσατε να καταγράψετε χρόνο.",
  "DirectlyAccessTheIssuesAndUpdateTime":"Άμεση πρόσβαση στα θέματα και ενημέρωση του χρόνου",
  "DirectlyAccessTheIssuesAndUpdateTimeDescription":"Κάντε κλικ στο στοιχείο του ημερολογίου εργασίας για να αποκτήσετε άμεση πρόσβαση στα ζητήματα και να επεξεργαστείτε τον παρακολουθούμενο χρόνο σας",
  "AlsoAvailableInDarkMode":"Διατίθεται επίσης σε σκοτεινή λειτουργία",
  "DirectlyLogWorkOnTheCalendarVisually":"Άμεση καταγραφή των εργασιών στο ημερολόγιο με οπτικό τρόπο",
  "ClickOnTheCalendarToCreateNewWorklog":"Κάντε κλικ στο ημερολόγιο για να δημιουργήσετε νέο ημερολόγιο εργασίας",

  "AppsForAtlassian":"Εφαρμογές για την Atlassian",
  "YCL_p1":"Απεικονίστε όλα τα αρχεία καταγραφής εργασιών σας σε ένα ημερολόγιο με προβολές μήνα, εβδομάδας, εβδομάδας εργασίας, ημέρας.",
  "YCL_p2":"Καταγράψτε εργασίες απευθείας από το ημερολόγιο επιλέγοντας οπτικά τη χρονοθυρίδα.",
  "YCL_p3":"Εντοπίστε αν ξεχάσατε να παρακολουθήσετε τον χρόνο για τα φύλλα εργασίας σας.",
  "YCL_p4":"Διαθέσιμο στη γλώσσα σας: Αγγλικά (Ηνωμένο Βασίλειο), αγγλικά (ΗΠΑ), κινέζικα (απλοποιημένα), κινέζικα (παραδοσιακά), τσεχικά, δανικά, ολλανδικά, εσθονικά, φινλανδικά, γαλλικά, γερμανικά, ουγγρικά, ισλανδικά, ιταλικά, ιαπωνικά, κορεατικά, νορβηγικά, πολωνικά, πορτογαλικά (Βραζιλία), πορτογαλικά (Πορτογαλία), ρωσικά, ισπανικά, σουηδικά, τουρκικά.",

  "Kakeibo":"Kakeibo",
  "Genea":"Genea",
  "FinancialPortfolio":"Χρηματοοικονομικό χαρτοφυλάκιο για το Jira",
  "BringRealFinancialPortfolio":"Ενσωματώστε πραγματική διαχείριση χρηματοοικονομικού χαρτοφυλακίου στο Jira. Παρακολουθήστε προϋπολογισμούς, CapEx/OpEx και κόστη έργων σε ένα μόνο μέρος.",
  "YFPAboutQ":"Πόσο μας κοστίζουν πραγματικά τα έργα μας στο Jira;",
  "YFPAbout":"Χρηματοοικονομικό χαρτοφυλάκιο για το Jira\nΟι επικεφαλής των οικονομικών και τα PMO δυσκολεύονται να απαντήσουν σε μια απλή ερώτηση:\nΠόσο μας κοστίζουν πραγματικά τα έργα μας στο Jira;\nΤο Jira παρακολουθεί την εργασία.\nΤα οικονομικά παρακολουθούν τους προϋπολογισμούς.\nΑυτή η εφαρμογή συνδέει επιτέλους τα δύο.\n\nΤο Financial Portfolio μετατρέπει το Jira σε μια ελαφριά πλατφόρμα PPM + χρηματοοικονομικού σχεδιασμού — χωρίς να χρειάζονται ακριβά εργαλεία για επιχειρήσεις.",
  "YFPPorfolioQ":"Προϋπολογισμοί χαρτοφυλακίου & παρακολούθηση",
  "YFPPorfolioP":"Δημιουργήστε χαρτοφυλάκια σε πολλά έργα Jira και ορίστε: Ποσό προϋπολογισμού, Νόμισμα, Εύρος ημερομηνιών, Περιλαμβανόμενα έργα, ομάδες. Παρακολουθήστε αυτόματα τα πραγματικά κόστη καθώς η εργασία πραγματοποιείται στο Jira.",
  "YFPPorfolioListQ":"Χαρτοφυλάκια",
  "YFPPorfolioListP":"Δημιουργήστε χρηματοοικονομικά χαρτοφυλάκια που συνδυάζουν πολλαπλά έργα Jira και δείτε αμέσως: Προϋπολογισμό έναντι πραγματικού κόστους, ρυθμό κατανάλωσης πόρων έργου σε πραγματικό χρόνο, ανάλυση CapEx έναντι OpEx, κόστος ανά ζήτημα και έργο, εξαγώγιμες χρηματοοικονομικές αναφορές. Όλα τροφοδοτούνται απευθείας από τα αρχεία καταγραφής εργασίας του Jira.",
  "CostQ":"Αυτόματος υπολογισμός κόστους",
  "CostP":"Μετατρέψτε την παρακολούθηση χρόνου σε πραγματικά οικονομικά δεδομένα. Η εφαρμογή: Διαβάζει τα αρχεία καταγραφής εργασίας του Jira, Εφαρμόζει ωριαίες χρεώσεις, Υπολογίζει καθημερινά το πραγματικό κόστος των έργων. Χωρίς υπολογιστικά φύλλα. Χωρίς χειροκίνητη εργασία.",
  "RatesQ":"Τιμές",
  "RatesP":"Ορίστε ωριαία τιμή ανά έργο, ομάδα, συνολικά",
  "ReportQ":"Οικονομικές αναφορές CSV",
  "ReportP":"Εξαγάγετε οικονομικά δεδομένα χαρτοφυλακίου σε δευτερόλεπτα. Ιδανικό για: Ομάδες χρηματοοικονομικών, αναφορές CFO, προγραμματισμό προϋπολογισμού, υποστήριξη ελέγχου",
  "SettingsQ":"Ταξινόμηση CapEx έναντι OpEx",
  "SettingsP":"Υποστήριξη λογιστικών και ελεγκτικών απαιτήσεων. Ταξινόμηση εργασιών σε: Αποσβέσιμη ανάπτυξη (CapEx), Λειτουργική εργασία (OpEx). Δημιουργία εξαγώγιμων αναφορών έτοιμων για τις ομάδες χρηματοοικονομικών."
};

export const documents = {
};
